export default {
      id: "ic_close_circle_dark-usage",
      viewBox: "0 0 17 17",
      url: "/" + "images/icons.3.109.2.svg#ic_close_circle_dark-usage",
      toString: function () {
        return this.url;
      }
    }